import { profiles } from "@shared/api/services"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "react-toastify"
import { reachGoal } from "@utils/lib/yandexMetrika"

// Редактирование профиля члена семьи. Аргумент: { id, ...fields }.
export const useUpdateFamilyProfile = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: ({ id, ...data }) => profiles.update(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries(['family-profiles'])
			toast.success('Данные обновлены')
			reachGoal('update-child-profile')
		},
	})

	return mutation
}
